<template>
  <div>
    <el-dialog
      :title="title"
      width="600px"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      custom-class="customW"
      :before-close="handleClose"
    >
      <el-form :model="form" size="small" label-width="100px">
        <el-form-item label="权限名称：">
          <el-input v-model="form.authTitle" placeholder="请输入权限名称" clearable style="width:60%"></el-input>
        </el-form-item>
        <el-form-item label="KEY：">
          <el-input v-model="form.authKey" placeholder="请输入KEY" clearable style="width:60%"></el-input>
        </el-form-item>
        <el-form-item label="是否为菜单：">
          <el-radio-group v-model="form.isMenu" @change="isMenuChange">
            <!-- <el-radio :label="0">否</el-radio> -->
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="权限类型：" v-if="form.isMenu == 0">
          <el-radio-group v-model="form.authType">
            <el-radio :label="1">页面</el-radio>
            <el-radio :label="2">功能</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="使用接口：" v-if="form.isMenu == 0">
          <el-select v-model="routeIdList" @change="changeRouteId" filterable multiple placeholder="请选择" style="width:60%">
            <el-option
              v-for="item in postList"
              :key="item.id"
              :label="item.route_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()" size="small">取 消</el-button>
        <el-button type="primary" @click="confirm()" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// authOperate
import {getRouteList,authOperate} from "@/api/auth.js"
export default {
  name: "createAuth",
  data() {
    return {
      dialogFormVisible:false,
      title:"新增权限",
      postList:[],
      form:{
        authTitle:"",
        authKey:"",
        isMenu:1,
        authType:0,
        routeId:""
      },
      routeIdList:[]
    };
  },
  methods: {
    async isShow(val,type) {
      this.dialogFormVisible = true
      this.getRouteList()
      if(type == "edit"){
        this.title = "修改权限"
        this.form.authId = val.id
        this.form.isMenu = val.is_menu
        this.form.authType = val.auth_type
        this.form.authTitle = val.auth_title
        this.form.authKey = val.auth_key
      } else {
        this.title = "新增权限"
      }
    },
    async getRouteList() {
      const {code,data} = await getRouteList()
      if(code == 200){
        this.postList = data
      }
    },
    async confirm(){
      const {code} = await authOperate(this.form)
      if(code === 200){
        this.close()
        this.$message.success('操作成功')
        this.$parent.allAuthList();
      }
    },
    changeRouteId(val){
      this.form.routeId = val.join(",")
    },
    isMenuChange(val){
      if(val == 1){
        this.form.authType = 0
        this.form.routeId = ""
        this.routeIdList = []
      }
    },
    close(){
      this.dialogFormVisible = false
      this.form = {
        authTitle:"",
        authKey:"",
        isMenu:1,
        authType:0,
        routeId:""
      }
      this.routeIdList = []
    },
    handleClose(done){
      done();
      this.close()
    },
  }
};
</script>

<style lang="scss" scoped>
/deep/ .customW{
  border-radius: 10px !important;
  .el-dialog__header {
    border-bottom: 1px solid #e8eaec;
    .el-dialog__title{
      font-size: 14px;
      color: #17233d;
      font-weight: 700;
    }
  }
  .el-dialog__footer{
    border-top: 1px solid #e8eaec;
  }
}

</style>
